//------------- TECNICOS ---------

//importações
import React from "react";
import { useState, useEffect } from "react";
import "./styles.css";

import Requests from "../../services/requests";
import { Link } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";

//icons
import { BiRefresh } from "react-icons/bi";

import RoundedButton from "../../components/btn-rounded";
import DatagridUsers from "../../components/datagrid-users";
import { FiArrowLeft, FiChevronLeft } from "react-icons/fi";

//setselectedtec envia o suuario para a página Agenda
const Tecnicos = ({ token, setSelectedTec, setPopup }) => {
    const [openForm, setOpenForm] = useState(false);
    const [loading, setLoading] = useState(false);

    const [selected, setSelected] = useState({}); //usuario selecionado do datagrid

    const [nome, setNome] = useState("");
    const [email, setEmail] = useState("");

    const clearForm = () => {
        setNome("");
        setEmail("");
    };

    //enviar o formulário para a api
    const handleSubmit = async (e) => {
        e.preventDefault();
        let config = { headers: { "x-access-token": token } };
        let object = {
            nome: nome,
            email: email,
        };
        //verifica se algum item foi selecionado, caso tenha sido,
        //será chamada a rota de put (edição),
        //caso nenhum item tenha sido selecionado, cadastra um novo
        if (!selected.id) {
            setLoading(true);
            await Requests.postTecnicos(object, config)
                .then((res) => {
                    if (!res.invalido) {
                        toast.success("Usuário cadastrado com sucesso!");
                        let msg =
                            "Usuário cadastrado!" +
                            "\n\n" +
                            "Uma senha provisória será enviada para: \n" +
                            email +
                            "\n\n" +
                            "Caso o técnico não tenha recebido o alerta de criação de conta" +
                            ", exclua o cadastro e realize novamente." +
                            "\n\n" +
                            "lembre-se de verificar a caixa de SPAM" +
                            "\n\n";
                        setLoading(false);
                        clearForm();
                        setTimeout(() => {
                            toast((t) => (
                                <div style={{ fontFamily: "var(--font-primary)" }}>
                                    {msg}
                                    <button
                                        style={{
                                            cursor: "pointer",
                                            borderRadius: 500,
                                            border: "0.5px solid black",
                                            width: "fit-content",
                                            height: "auto",
                                            aspectRatio: 1,
                                            marginRight: 0,
                                            marginLeft: "auto",
                                            fontFamily: "var(--font-primary)",
                                            backgroundColor: "var(--color-green)",
                                            color: "var(--color-white)",
                                        }}
                                        onClick={() => toast.dismiss(t.id)}
                                    >
                                        OK
                                    </button>
                                </div>
                            ));
                        }, 2000);
                    } else {
                        if (res.mensagem === "Email duplicado!") {
                            toast.error(
                                "Não foi possível cadastrar o usuário\n Verifique se o email já está cadastrado"
                            );
                        } else if (res.mensagem === "Nenhum email relacionado encontrado.") {
                            toast.error(
                                "Não foi possível cadastrar o usuário\n Verifique se o email realmente existe"
                            );
                        } else {
                            toast.error("Não foi possível cadastrar o usuário");
                        }
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    toast.error("Não foi possível editar o usuário");
                    console.log(err);
                });
        } else {
            setLoading(true);
            object = { ...object, id: selected.id };
            await Requests.putTecnicos(object, config)
                .then((res) => {
                    if (!res.invalido) {
                        toast.success("Usuário editado com sucesso!");
                        setLoading(false);
                        clearForm();
                    } else {
                        if (res.mensagem === "Email duplicado!") {
                            toast.error(
                                "Não foi possível editar o usuário\n Verifique se o email já está cadastrado"
                            );
                        } else if (res.mensagem === "Nenhum email relacionado encontrado.") {
                            toast.error(
                                "Não foi possível editar o usuário\n Verifique se o email realmente existe"
                            );
                        } else {
                            toast.error("Não foi possível editar o usuário");
                        }
                        setLoading(false);
                    }
                })
                .catch((err) => {
                    toast.error("Não foi possível editar o usuário");
                    console.log(err);
                });
        }
    };

    useEffect(() => {
        handleSelect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected]);

    //seleciona um item e envia para o form
    const handleSelect = () => {
        if (selected) {
            if (selected.nome) {
                setNome(selected.nome);
            } else {
                setNome("");
            }
            if (selected.email) {
                setEmail(selected.email);
            } else {
                setEmail("");
            }
        }
    };
    const handleClear = () => {
        setSelected({});
    };

    return (
        <div className="div-body-tecnicos-component">
            <div>
                <Toaster />
            </div>
            {setPopup ? 
            <Link className="txt-button voltar" onClick={() => {setPopup()}} to="/mapa">
                <FiArrowLeft /> Voltar
            </Link>: 
            <Link className="txt-button voltar" to={"/agenda"}>
                <FiArrowLeft /> Voltar
            </Link>}
            <label className="txt-title">Técnicos</label>
            <form id="tec" onSubmit={(e) => handleSubmit(e)}>
                {openForm && (
                    // formulário de cadastro de usuário
                    <fieldset id="tec-form">
                        <legend>Cadastrar técnico</legend>
                        <div className="div-txt-area">
                            <label>Nome</label>
                            <input
                                required
                                id="nome"
                                name="nome"
                                value={nome}
                                onChange={(e) => {
                                    setNome(e.target.value);
                                }}
                                maxLength={200}
                                type="text"
                                className="input-text"
                                placeholder="insira o nome do técnico"
                            ></input>
                        </div>
                        <div className="div-txt-area">
                            <label>Email</label>
                            <input
                                required
                                id="email"
                                name="email"
                                value={email}
                                onChange={(e) => {
                                    setEmail(e.target.value);
                                }}
                                maxLength={200}
                                type="text"
                                className="input-text"
                                placeholder="Insira o email do técnico"
                            ></input>
                        </div>
                        <div className="buttons">
                            <RoundedButton
                                event={handleClear}
                                text={"Limpar"}
                                stl="yellow-button"
                            ></RoundedButton>
                            <RoundedButton
                                event={handleClear}
                                text={"Ir para agenda"}
                                stl="yellow-button"
                            ></RoundedButton>
                            <RoundedButton
                                type="submit"
                                text={Object.values(selected).length > 0 ? "Salvar" : "Cadastrar"}
                            ></RoundedButton>
                        </div>
                        {loading === true && (
                            <div
                                style={{ position: "relative", marginTop: -55, top: "120px" }}
                                id="dg-list"
                                className="refresh-page"
                            >
                                <BiRefresh />
                            </div>
                        )}
                    </fieldset>
                )}
                {/* exibe o datagrid com as informações recebidas */}
                <div className="datagrid">
                    <DatagridUsers
                        setSelectedTec={setSelectedTec}
                        token={token}
                        openForm={openForm}
                        setOpenForm={setOpenForm}
                        setSelectedItem={setSelected}
                        setPopup={setPopup}
                    ></DatagridUsers>
                </div>
            </form>
        </div>
    );
};

export default Tecnicos;
